module.exports = __webpack_public_path__ + "img/six1.4ee4b1a1.jpg";